import { render } from "./InvitesPage.vue?vue&type=template&id=003bc91d&scoped=true"
import script from "./InvitesPage.vue?vue&type=script&lang=js"
export * from "./InvitesPage.vue?vue&type=script&lang=js"

import "./InvitesPage.vue?vue&type=style&index=0&id=003bc91d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003bc91d"]])

export default __exports__